import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import { UpdateIdentityDocumentInterface } from '../models/updateidentitydocument';
import _ from 'lodash';
import { PassengerInterface } from '../models/passenger';

export interface UpdateIdentityDocumentState {
  model: UpdateIdentityDocumentInterface;
}

const initialState: UpdateIdentityDocumentState = {
  model: {
    route: 'ck_updateidentitydocument',
    fullCkiProcess: false,
    messages: {},
    identityDocumentData: undefined,
    validationResult: {},
    disabledSubmit: true,
    disabledBack: true,
    matchingPnrs: undefined,
    adoc: false,
  },
};

export const updateIdentityDocumentSlice = createSlice({
  name: 'updateIdentityDocument',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setUpdateIdentityDocumentModel: (state, action) => {
      state.model = action.payload;
    },
    setUpdateIdentityDocumentModelAttribute: (
      state,
      action: PayloadAction<{ key: string; value: any }>
    ) => {
      const key = action.payload.key;
      const value = action.payload.value;
      Object.assign(state.model, { [key]: value });
    },
    setResponseForPassenger: (
      state,
      action: PayloadAction<{
        data: any;
      }>
    ) => {
      const data = action.payload.data;
      const key = data.eTicket;
      let pax = state.model.matchingPnrs[0].flights[0].passengers.find(
        (pax: PassengerInterface) => pax.ticket.ticketNumber === key
      );

      _.set(state.model.validationResult, pax.paxIdReference, data);
    },
    resetMesages: (state) => {
      state.model.messages = null;
    },
  },
});

export const {
  setUpdateIdentityDocumentModel,
  setUpdateIdentityDocumentModelAttribute,
  setResponseForPassenger,
  resetMesages,
} = updateIdentityDocumentSlice.actions;

export const selectUpdateIdentityDocumentModel = (state: RootState) => state.updateidentitydocument.model;

export default updateIdentityDocumentSlice.reducer;
